import { Component, OnInit, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { SemControlComponent } from '../../sem-control/sem-control.component';
import { ValueAccessorBase } from '../../shared/value-accessor/value-accessor-base';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { SemParameterDialogComponent } from '../../dialogs/sem-parameter-dialog/sem-parameter-dialog.component';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'one-to-many-section',
    templateUrl: './one-to-many-section.component.html',
    styleUrls: ['./one-to-many-section.component.css'],
    providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: OneToManySectionComponent, multi: true }],
    standalone: false
})
export class OneToManySectionComponent extends ValueAccessorBase<any> implements OnInit {

  @Input() bindingPropertyName: any;
  @Input() maxCount: number = -1;
  @Input() sectionTransferUrl: any;
  @Input() sectionContent: any;
  @Input() contentTemplate: any;
  @Input() section: any;
  @Input() forwardEntityName: any;
  @Input() forwardEntities: any;
  @Input() number: any;
  @Input() actions: any = [];
  @Input() hideRepeaterActionsCondition: string;
  @Input() isInline: any;
  @Input() deleteDisabled: boolean = true;
  @Input() orderEnabled: boolean = false;
  @Input() orderProperty: any = "";
  @Input() nestedRenderUrl:any = "";
  @Input() listingFields: any[];

  currentNumber: number = 0;
  showDD: boolean = false;
  isEditing: boolean = false;
  isAddConfirmed: boolean = false;

  private forwardEntSubs: any = null;


  @Output() removeSectionEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() reorderEvent: EventEmitter<any> = new EventEmitter<any>();

  super() { }

  ngAfterViewInit(): void {
    // for forward entitypurposes
    /*if(this.forwardEntityName != null && typeof this.forwardEntityName != "undefined"){
      this.forwardEntSubs = this.utility.currentDropdownSelectedValue.subscribe(model => {

        if (typeof model != "undefined" && model != null && model.SelectedDropDownBinding != null && typeof model.SelectedDropDownBinding != "undefined") {        
          if(model.SelectedDropDownBinding === this.forwardEntityName && this.model != null && typeof this.model != "undefined"){
            this.model[this.forwardEntityName] = model.SelectedValue;
          }
        }

      });
    }*/
  }


  ngOnInit() {
  }

  ngOnDestroy(): void {

    if (typeof this.forwardEntSubs != "undefined" && this.forwardEntSubs != null) {
      this.forwardEntSubs.unsubscribe();
    }
  }

  toggleDD() {
    this.dfms.globalForm.form.markAsDirty();
    this.showDD = !this.showDD;
  }
  // Close the dropdown if a click occurs outside
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    const clickedElement = event.target as HTMLElement;
    if (!clickedElement.closest('.manipulate-section')) {
      this.showDD = false;
    }
  }


  removeSection(section) {
    this.removeSectionEvent.emit(section);
    this.changeDetection.detectChanges();
  }
  showRepeaterActions() {
    if (this.hideRepeaterActionsCondition != null && typeof this.hideRepeaterActionsCondition != "undefined" && this.hideRepeaterActionsCondition.length > 0) {
      var evalResponse = eval(this.hideRepeaterActionsCondition);
      if (evalResponse == true) {
        return false;
      }
      return true;
    }
    return true;
  }

  evaluateSectionAction(action) {
    if (action.FormAction) {

      this.restProviderService.getDataGET("api/actions/" + action.FormAction, "application/json").subscribe((data: any) => {
        let formAction = JSON.parse(data);





        if (formAction) {
          if (formAction.ParameterForm != null && typeof formAction.ParameterForm != "undefined" && formAction.ParameterForm.Id > 0) {
            var reportId = null;
            if (formAction.ParameterForm.Report != null && typeof formAction.ParameterForm.Report != "undefined") {
              reportId = formAction.ParameterForm.Report.Id;
            }

            const dialogRef = this.dialog.open(SemParameterDialogComponent, {
              data: {
                parameterFormId: formAction.ParameterForm.Id,
                reportId: reportId,
                customHeaderTitle: formAction.ParameterForm.CustomHeaderTitle,
                customCssClass: formAction.ParameterForm.CustomCssClass
              }
            });

            dialogRef.afterClosed().subscribe(returnData => {
              if (returnData != null && typeof returnData != "undefined") {
                // only call action if parameter popup was confirmed (not cancled - close button)
                if (returnData.Canceled == false) {
                  var inputParametersModel = returnData["Model"];
                  this.actionsService.callAction(formAction, this.section, null, null, this, action.BulkAction, inputParametersModel, formAction.OnlyClientLogic, false, action.BulkExport, formAction.SkipBulkActionApiMethod);
                }
              }
            });
          } else {
            // just call action without parameters form popup
            this.actionsService.callAction(formAction, this.section, null, null, this, action.BulkAction, null, formAction.OnlyClientLogic, false, action.BulkExport, formAction.SkipBulkActionApiMethod);
          }
        }





        return formAction;
      }, error => {
        console.log(error);
      });

    }
    else if (action.ActionBody) {
      this.evaluateAction(action.ActionBody);
    }
  }

  up() {
    this.reorderEvent.emit({ section: this.section, direction: 'up' })
  }
  down() {
    this.reorderEvent.emit({ section: this.section, direction: 'down' })
  }

  get isNewItem(): boolean {
    return !this.section || !this.section.Id || this.section.Id <= 0;
  }

  get showCompactDisplay(): boolean {
    return this.listingFields && this.listingFields.length > 0
      && (!this.isNewItem || this.isAddConfirmed) && !this.isEditing && !this.isInline;
  }

  startEdit() {
    this.isEditing = true;
  }

  cancelEdit() {
    this.isEditing = false;
  }

  confirmAdd() {
    this.isAddConfirmed = true;
    this.dfms.globalForm.form.markAsDirty();
  }

  getFieldValue(field: any): string {
    if (!this.section) return '';
    let val = this.dfms.getValue(this.section, field.Binding);
    if (val === null || typeof val === 'undefined') return '';
    if (typeof val === 'object' && val !== null && val.Title) return val.Title;
    return val.toString();
  }

  // StringLink listing field: turn the raw value into an href. Values without a scheme
  // (e.g. "www.example.com") get "https://" so the browser does not resolve them relative to the app.
  getLinkHref(value: any): string {
    if (value === null || typeof value === "undefined") {
      return "";
    }
    let url = value.toString().trim();
    if (url.length == 0) {
      return "";
    }
    if (/^[a-z][a-z0-9+.-]*:/i.test(url) || url.startsWith("/")) {
      return url;
    }
    return "https://" + url;
  }

  triggerSplitSearch(lf: any) {
    if (environment.useInlineSearch === true && this.dfms.isFormReadOnly === true) {
      let value = this.getFieldValue(lf);
      if (!value) return;

      this.searchService.splitSearchEnabled = true;
      let bindingProp = this.bindingPropertyName + "." + lf.Binding;

      let e = this.searchService.splitSearchKeywords.filter(i => i.bindingProperty == bindingProp);
      if (e.length > 0) {
        e[0].value = value;
      } else {
        this.searchService.splitSearchKeywords.push({
          value: value,
          bindingProperty: bindingProp,
          name: this.translationsService.translate(lf.Name)
        });
      }

      this.searchService.splitSearchS.next(undefined);
    }
  }

}
